import { render, staticRenderFns } from "./bimText.vue?vue&type=template&id=cf81baf6&scoped=true&lang=html&"
import script from "./bimText.vue?vue&type=script&lang=js&"
export * from "./bimText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf81baf6",
  null
  
)

export default component.exports